<template>
  <div>
    <a-card
      :style="{ marginBottom: '1em' }"
      :header="$t('common.search')"
      :editable="false"
    >
      <template
        #header-buttons
      >
        <div class="is-pulled-right is-flex buttons">
          <b-button
            icon-left="filter-remove"
            @click="() => $store.dispatch('parts/resetFilters')"
          >
            {{ $t('common.navigation.reset_filters') }}
          </b-button>
          <a-select
            :manual-doc="userDoc"
            field="routes.parts.orderBy"
            :label="$t('common.order')"
            :options="keys($store.getters['parts/orderOptions'])"
            :labels="$store.getters['parts/orderOptions']"
          />
        </div>
      </template>

      <filters />
      <a-input
        :style="{ marginTop: '1em' }"
        :manual-doc="userDoc"
        field="routes.parts.search"
        :label="$t('common.quick_search')"
      />
    </a-card>
    <a-table
      :columns="user.routes.parts.columns"
      :data="$store.getters['parts/displayedItems']"
    />
    <more-docs-button
      module="parts"
    />
    <add-button />
  </div>
</template>

<script>
import ATable from '@/components/ATable'
import MoreDocsButton from '@/components/MoreDocsButton'
import { mapGetters, mapActions } from 'vuex'
import { keys } from 'lodash'
import Filters from './Parts/Filters'
import AddButton from './Parts/AddButton'

export default {
  components: {
    AddButton,
    Filters,
    MoreDocsButton
  },
  data() {
    return {
      userDoc: { module: 'user' }
    }
  },
  created () {
    this.$store.dispatch('parts/fetchDocs')
  },
  methods: {
    keys
  }
}
</script>
